export default __webpack_public_path__ + "static/gotta-have-more-cowbell-loud-5950cf1513c2e4a2b243ff44653342cb.m4a";